import { render, staticRenderFns } from "./PatentNoteType.vue?vue&type=template&id=106cd386&"
import script from "./PatentNoteType.vue?vue&type=script&lang=js&"
export * from "./PatentNoteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports